import BackButton from "../../../components/buttons/BackButton"
import { Button } from "../../../components/ui/button"

interface AuthHeaderProps {
    onBackClick?: () => void
    actionButtonLabel?: string
    onActionButtonClick?: () => void
}

const AuthHeader: React.FC<AuthHeaderProps> = ({ onBackClick, actionButtonLabel, onActionButtonClick }) => {
    return (
        <div className="w-full fixed top-0 left-0 z-50 bg-white">
            <div className="w-full flex justify-between items-center px-4 sm:px-8 min-h-[80px]">
                {
                    onBackClick ? <BackButton onClick={onBackClick}/> : <div></div>
                }
                {actionButtonLabel && onActionButtonClick && (
                    <Button
                        variant={'tertiary'}
                        size={'lg'}
                        onClick={onActionButtonClick}
                    >
                        {actionButtonLabel}
                    </Button>
                )}
            </div>
        </div>
    )
}

export default AuthHeader
